import styled from 'styled-components';
import { Layout } from '@axiom/ui';

export const CardLayout = styled(Layout)`
  height: 100%;
`;
